export enum TagManagerFilter {
	ALL = "all",
	SUGGESTIONS = "suggestions"
}


export enum TagManagerTab {
	ALL = "all-items",
	SUGGESTIONS = "suggestions"
}


export enum TagManagerSortBy {
	ALPHABETICAL = "alphabetical",
	ROAM = "roam",
	USAGE = "usage"
}
